import React from 'react';
import { isNewDemoCompany } from 'Utils/index';
// import { COMPANY_TEXT_ID } from 'src/newSrc/constants/companyTextIdConstants';

export const SCREEN_CONFIG = {
  default: {
    ScreenConfigNotFoundScreen: React.lazy(
      () => import('../default/ScreenConfigNotFoundScreen')
    ),
    // RFQCreate: React.lazy(() => import('../RFQ/CreateReverseAuction/index')),
    SeekerHomeScreen: React.lazy(() => import('../default/seekerHomeScreen')),
    RFQCreate: React.lazy(() => import('../default/CreateRFQ/RFQCreate')),
    EximRFQCreate: React.lazy(() => import('../default/EximCreateRFQ')),
    RfqDashboardScreen: React.lazy(
      () => import('../default/RfqDashboardScreen')
    ),
    BidDetailsScreen: React.lazy(
      () => import('../default/BidDetailsScreen/bidDetailsScreenManager')
    ),
    ChallengePriceForm: React.lazy(
      () => import('../default/ChallengePriceForm')
    ),
    ContractRecordsScreen: React.lazy(
      () => import('../default/ContractRecordsScreen')
    ),
    ContractRecordDetailsScreen: React.lazy(
      () => import('../default/ContractRecordDetails')
    ),
    TransporterBidDetailScreen: React.lazy(
      () => import('../default/TransporterBidDetailScreen')
    ),
    RouteMasterScreen: React.lazy(() => import('../default/RouteMaster')),
    AuditDashboardScreen: React.lazy(() => import('../DPL/AuditDashboard')),
    EximCargoTrackingScreen: React.lazy(
      () => import('../BEAM/EXIMCargoTracking/EXIMCargoTracking')
    ),
    DphDashboardScreen: React.lazy(
      () => import('../COROMANDEL/DphDashboard/DphDashboard')
    ),
    ReportsScreen: React.lazy(() => import('../default/Reports')),
    GenerateContractsScreen: React.lazy(
      () => import('../default/GenerateContracts')
    ),
    ViewGeneratedContractsScreen: React.lazy(
      () => import('../default/ViewGeneratedContracts')
    ),
    CreateNewContractsScreen: React.lazy(
      () => import('../default/ViewGeneratedContracts/CreateNewContracts')
    ),
    ViewContractDetailsScreen: React.lazy(
      () => import('../default/ViewGeneratedContracts/ViewContractDetails')
    ),
    SecondaryContractsScreen: React.lazy(
      () => import('../default/SecondaryContracts')
    ),
    AddEditSecondaryContractScreen: React.lazy(
      () => import('../default/SecondaryContracts/AddEdit')
    ),
    GroupsAndTransportersScreen: React.lazy(
      () => import('../default/settings/GroupsAndTransporters')
    ),
    EventManagementScreen: React.lazy(() => import('../EMAMI/EventManagement')),
    EventStatusScreen: React.lazy(
      () => import('../EMAMI/EventManagement/EventStatus')
    ),
    WinningTransportersScreen: React.lazy(
      () => import('../EMAMI/EventManagement/WinningTransporters')
    ),
    EventCreateScreen: React.lazy(
      () => import('../EMAMI/EventManagement/EventForm')
    ),
    EventUploadRfqsScreen: React.lazy(
      () => import('../EMAMI/EventManagement/UploadRfqs')
    ),
    EventPreviewScreen: React.lazy(
      () => import('../EMAMI/EventManagement/Preview')
    ),
    EventRfqEditScreen: React.lazy(
      () => import('../EMAMI/EventManagement/EditRfq')
    ),
  },
  newDemoCompany: {
    SeekerHomeScreen: React.lazy(() => import('../DemoCompany/DemoHome')),
  },
  // [COMPANY_TEXT_ID.DPL_SAP]: {
  //   RaiseIndentScreen: React.lazy(() => import('../dpl/RaiseIndentScreen')),
  // },
  // beams: {},
  // emami: {},
};

// Helper function to get screen component by company and screen component name
export const getScreenComponent = (COMPANY_TEXT_ID, screenComponentName) => {
  // Check if company has custom screen
  // if (COMPANY_TEXT_ID) {
  //   const companyScreenConfig = SCREEN_CONFIG[COMPANY_TEXT_ID];
  //   if (companyScreenConfig && companyScreenConfig[screenComponentName]) {
  //     return companyScreenConfig[screenComponentName];
  //   }
  // }
  if (isNewDemoCompany() && SCREEN_CONFIG.newDemoCompany[screenComponentName]) {
    return SCREEN_CONFIG.newDemoCompany[screenComponentName];
  }

  // Use default screen if available
  if (SCREEN_CONFIG.default[screenComponentName]) {
    return SCREEN_CONFIG.default[screenComponentName];
  }

  // Fallback to ScreenConfigNotFoundScreen if screen is not found
  return SCREEN_CONFIG.default.ScreenConfigNotFoundScreen;
};
